import { Type } from '@hugendubel/ws_client';
import { WsBaseAddress } from './WsBaseAddress';
import { WsSalutation } from './WsSalutation';

export class WsAddress extends WsBaseAddress {
    salutation: WsSalutation;
    addition?: string;
    street?: string;
    houseNumber?: string;

    constructor(
        encodedId: string,
        salutation: WsSalutation,
        firstName: string | undefined,
        lastName: string | undefined,
        companyName: string | undefined,
        addition: string | undefined,
        street: string | undefined,
        houseNumber: string | undefined,
        zipCode: string,
        city: string,
        countryCodeIso: string,
        active: boolean
    ) {
        super(encodedId, firstName, lastName, companyName, zipCode, city, countryCodeIso, active);

        this.salutation = salutation;
        this.addition = addition;
        this.street = street;
        this.houseNumber = houseNumber;
    }

    isCompanyAddress(): boolean {
        return this.salutation === WsSalutation.COMPANY;
    }

    static fromApi(json: any): WsAddress {
        // Needs to be present in JSON since it is used to differ
        // Packstation addresses from others
        Type.boolean(json.packstation, 'Packstation.packstation');

        return new WsAddress(
            Type.string(json.addrDataId, 'Address.addrDataId'),
            WsSalutation.fromCode(Type.notEmptyString(json.salutationCode, 'Address.salutationCode')),
            Type.optional.string(json.firstName, 'Address.firstName'),
            Type.optional.string(json.lastName, 'Address.lastName'),
            Type.optional.string(json.companyName, 'Address.companyName'),
            Type.optional.string(json.addition, 'Address.addition'),
            Type.optional.string(json.street, 'Address.street'),
            Type.optional.string(json.houseNumber, 'Address.houseNumber'),
            Type.string(json.zipCode, 'Address.zipCode'),
            Type.string(json.city, 'Address.city'),
            Type.string(json.countryCodeIso, 'Address.countryCodeIso'),
            Type.boolean(json.active, 'Address.active')
        );
    }
}
